__turbopack_context__.v({
  "clearButton": "SearchBar-module__KdGN3G__clearButton",
  "iconButton": "SearchBar-module__KdGN3G__iconButton",
  "noResults": "SearchBar-module__KdGN3G__noResults",
  "resultBrand": "SearchBar-module__KdGN3G__resultBrand",
  "resultInfo": "SearchBar-module__KdGN3G__resultInfo",
  "resultItem": "SearchBar-module__KdGN3G__resultItem",
  "resultTitle": "SearchBar-module__KdGN3G__resultTitle",
  "searchButton": "SearchBar-module__KdGN3G__searchButton",
  "searchButtonWithClear": "SearchBar-module__KdGN3G__searchButtonWithClear",
  "searchForm": "SearchBar-module__KdGN3G__searchForm",
  "searchInput": "SearchBar-module__KdGN3G__searchInput",
  "searchResults": "SearchBar-module__KdGN3G__searchResults",
  "visible": "SearchBar-module__KdGN3G__visible",
});
